import '../css/BrandComponent.css'
export default function BrandComponent({ imgSource, brand, padding='0px' }) {
    return (
        <div id="brand" style={{padding: padding}}>
            <a href={`/brand/${brand}`}>
                <img src={imgSource} alt='brand'/>
            </a>
        </div>
    );
}